import React, { createContext, useState } from 'react';
import { retrieveLanguage }               from '../helpers/storage';
const { Provider, Consumer }              = createContext();

const ContextStore = ({ comp, apollocon, axioscon, clientAndroid }) => {

  const defaultLanguage = retrieveLanguage() === null ? 'es-MX' : retrieveLanguage();
  const serviceApollo   = new apollocon('DEVELOP');
  const serviceAxios    = new axioscon('DEVELOP');
  const serviceAndroid  = new clientAndroid();

  const [conApollo,         setConApollo]              = useState(serviceApollo);
  const [conAxios,          setConAxios]               = useState(serviceAxios);
  const [clntAndroid,       setClientAndroid]          = useState(serviceAndroid);
  const [language,          setLanguage]               = useState(defaultLanguage);
  const [isToolbar,         setIsToolbar]              = useState(false);
  const [nextView,          setNextView]               = useState("documents");
  const [recomendationView, setRecomendationView]      = useState("IFEfront");
  const [viewResponse,      setViewResponse]           = useState("");
  const [typeAlert,         setTypeAlert]              = useState('');
  const [errors,            setErrors]                 = useState({});
  const [showForms,         setShowForms]              = useState({
    isVisibleGeneral:  false,
    isVisibleCURP:     false,
    isVisibleAdress:   false
  });
  const [isContinuo,        setIsContinuo]             = useState({
    documents:   true,
    selfie:      true,
    proofAdress: true,
    contact:     true,
  });

  /// information client
  const [informationClient, setInformationClient ]  = useState({
    uuidclient:      'sin',
    curp:            '',
    name:            '',
    firstname:       '',
    secondname:      '',
    datebirday:      '',
    rfc:             '',
    gender:          'M',
    maritalStatus:   'casado',
    electorKey:      '',
    ineNumber:       '',
    cityBirth:       '',
    stateBirth:      '',
    countryBirth:    '',
    nationality:     'MEXICANA',
    streetIFE:       '',
    cityIFE:         '',
    neighborhoodIFE: '',
    codePostal:      '',
    street:          '',
    numberExterior:  '',
    numberInterior:  '',
    neighborhood:    '',
    municipality:    '',
    state:           '',
    country:         '',
    phoneMain:       '',
    phoneSecondary:  '',
    email:           ''
  });

  /// documents client
  const [documentsClient, setDocumentsClient]       = useState({
    ifeFront:         '',
    ifeBack:          '',
    curp:             '',
    selfie:           '',
    proofAdress:      '',
    ifeFrontBase64:   '',
    ifeBackBase64:    '',
    curpBase64:       '',
    selfieBase64:     '',
    proofAdressBase64:''
  });

  const [modal, setModal]                           = useState({
    showModal:  false,
    closeModal: null,
    component:  null,
    customCss:  null,
    size:       'xl',
    backdrop:   null,
  });

  const [isMobile, setIsMobile]                     = useState(false);

  const [processOnboarding, setProcessOnboarding]   = useState("documents");
  const [progressoRegister, setProgressoRegister]   = useState(25);
  const [progressoCounter,  setProgressoCounter]    = useState(1);
  const [seeCURP, setSeeCURP ]                      = useState(false);
  const [showIMGCURP, setShowIMGCURP ]              = useState(false);
  const [pathUlr, setPathUrl]                       = useState("");
  const [loadWindowS, setLoadWindowS]               = useState(false);
  const [loadWindowC, setLoadWindowC]               = useState(false);
  const [loadWindowSE, setLoadWindowSE]             = useState(false);
  const [isAdmin, setIsAdmin]                       = useState(false);
  const [activeCam, setActiveCam]                   = useState(false);
  const [typeViewMovil, setTypeViewMovil]           = useState('');
  const [btnBack, setBtnBack]                       = useState(false);
  const [viewRecomendation, setViewRecomendation]   = useState(false);
  const [isEditingView, setIsEditingView]           = useState(false);
  const [isEditingPhotos, setIsEditingPhotos]       = useState(false);
  const [isBackView, setIsBackView]                 = useState(false);
  const [opColonias, setOpColonias]                 = useState([]);
  

  const contextValues = {
    modal,
    setModal,
    conApollo, 
    conAxios,  
    clntAndroid,
    language,
    setLanguage,
    isToolbar, 
    setIsToolbar,
    documentsClient, 
    setDocumentsClient,
    informationClient, 
    setInformationClient,
    nextView,
    setNextView,
    recomendationView, 
    setRecomendationView,
    viewResponse, 
    setViewResponse,
    typeAlert,         
    setTypeAlert,
    errors,
    setErrors,
    showForms,         
    setShowForms,
    isContinuo, 
    setIsContinuo,
    
    isMobile,
    setIsMobile,
    processOnboarding, 
    setProcessOnboarding,
    progressoRegister, 
    setProgressoRegister,
    progressoCounter,  
    setProgressoCounter,
    pathUlr, 
    setPathUrl,
    loadWindowS, 
    setLoadWindowS,
    loadWindowSE,
    setLoadWindowSE,
    seeCURP, 
    setSeeCURP,
    showIMGCURP, 
    setShowIMGCURP,
    loadWindowC, 
    setLoadWindowC,
    isAdmin, 
    setIsAdmin,
    activeCam, 
    setActiveCam,
    typeViewMovil, 
    setTypeViewMovil,
    btnBack, 
    setBtnBack,
    viewRecomendation, 
    setViewRecomendation,
    isEditingView, 
    setIsEditingView,
    isEditingPhotos, 
    setIsEditingPhotos,
    isBackView, 
    setIsBackView,
    opColonias, 
    setOpColonias
  }

  return <Provider value={contextValues}>{comp}</Provider>
}

const WrapperConsumer = (Component) => {
  return (props) => (
    <Consumer>
      {(context) => <Component {...props} context={context} />}
    </Consumer>
  )
}

export default WrapperConsumer
export { ContextStore, Consumer }
